module.exports = "build/assets/climateChange.01437eeb.png";